/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import {
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';

const HIGH_DENSITY_IMAGE_MULTIPLIER = 1.25;

export const CHANNEL_BACKGROUND_IMAGE = 'CHANNEL_BACKGROUND_IMAGE';
export const CHANNEL_LOGO_BANNER = 'CHANNEL_LOGO_BANNER';
export const COLLECTION_HERO_IMAGE = 'COLLECTION_HERO_IMAGE';
export const COLLECTION_HERO_LOGO_IMAGE = 'COLLECTION_HERO_LOGO_IMAGE';
export const PERSONALITY_HERO_AVATAR_IMAGE = 'PERSONALITY_HERO_AVATAR_IMAGE';
export const COLLECTION_THUMBNAIL_IMAGE = 'COLLECTION_THUMBNAIL_IMAGE';
export const COLLECTION_VIDEO_BANNER_IMAGE = 'COLLECTION_VIDEO_BANNER_IMAGE';
const EPG_LIVE_IMAGE = 'EPG_LIVE_IMAGE';
export const FOOTER_PROMO = 'FOOTER_PROMO';
const FUTURE_EPG_MODAL_IMAGE = 'FUTURE_EPG_MODAL_IMAGE';
const HOME_HEADER_TITLE_IMAGE = 'HOME_HEADER_TITLE_IMAGE';
const HOME_HERO_IMAGE = 'HOME_HERO_IMAGE';
const HOME_SMALL_PROMO_IMAGE = 'HOME_SMALL_PROMO_IMAGE';
const HOME_THUMBNAIL_IMAGE = 'HOME_THUMBNAIL_IMAGE';
const HOW_TO_WATCH_IMAGE = 'HOW_TO_WATCH_IMAGE';
export const LIVE_EPG_THUMBNAIL_IMAGE = 'LIVE_EPG_THUMBNAIL_IMAGE';
export const LIVE_PLAYER_BACKGROUND_IMAGE = 'LIVE_PLAYER_BACKGROUND_IMAGE';
export const MARKET_VIDEO_IMAGE = 'MARKET_VIDEO_IMAGE';
export const NETWORK_LOGO_IMAGE = 'NETWORK_LOGO_IMAGE';
export const POSTER_IMAGE = 'POSTER_IMAGE';
export const POSTER_OVERLAY_IMAGE = 'POSTER_OVERLAY_IMAGE';
export const POSTER_OVERLAY_LOGO_IMAGE = 'POSTER_OVERLAY_LOGO_IMAGE';
export const SEARCH_THUMBNAIL_IMAGE = 'SEARCH_THUMBNAIL_IMAGE';
export const SERIES_DETAIL_HERO_IMAGE = 'SERIES_DETAIL_HERO_IMAGE';
export const SERIES_DETAIL_LOGO_IMAGE = 'SERIES_DETAIL_LOGO_IMAGE';
const SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE = 'SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE';
export const SHOW_DETAIL_RELATED_THUMBNAIL_IMAGE = 'SHOW_DETAIL_RELATED_THUMBNAIL_IMAGE';
export const SMALL_PROMO_IMAGE = 'SMALL_PROMO_IMAGE';
const SPORT_THUMBNAIL_IMAGE = 'SPORT_THUMBNAIL_IMAGE';
export const WATCH_PLAYER_BACKGROUND_IMAGE = 'WATCH_PLAYER_BACKGROUND_IMAGE';
export const WATCH_RELATED_THUMBNAIL_IMAGE = 'WATCH_RELATED_THUMBNAIL_IMAGE';
const COLLECTION_THUMBNAIL_LIVE_IMAGE = 'COLLECTION_THUMBNAIL_LIVE_IMAGE';
export const COUNTDOWN_BANNER_IMAGE = 'COUNTDOWN_BANNER_IMAGE';
export const SEARCH_EPISODE_TILE_IMAGE = 'SEARCH_EPISODE_TILE_IMAGE';

const getImageSize = ({ context }) => {
  switch (context) {
    case COLLECTION_HERO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 540 },
        [SITE_PLATFORM_TABLET]: { width: 768, height: 432 },
        [SITE_PLATFORM_WEB]: { width: 1920, height: 1080 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1920, height: 1080 },
      };
    }
    case COLLECTION_THUMBNAIL_LIVE_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 278, height: 156 },
        [SITE_PLATFORM_TABLET]: { width: 356, height: 200 },
        [SITE_PLATFORM_WEB]: { width: 480, height: 270 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 794, height: 507 },
        hover: {
          [SITE_PLATFORM_MOBILE]: { width: 490, height: 276 },
          [SITE_PLATFORM_TABLET]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB_LARGE]: { width: 794, height: 507 },
        },
      };
    }
    case COLLECTION_HERO_LOGO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 80 },
        [SITE_PLATFORM_TABLET]: { height: 100 },
        [SITE_PLATFORM_WEB]: { height: 100 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 132 },
      };
    }
    case PERSONALITY_HERO_AVATAR_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 125 },
        [SITE_PLATFORM_TABLET]: { height: 170 },
        [SITE_PLATFORM_WEB]: { height: 200 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 250 },
      };
    }
    case COLLECTION_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 278, height: 156 },
        [SITE_PLATFORM_TABLET]: { width: 356, height: 200 },
        [SITE_PLATFORM_WEB]: { width: 480, height: 270 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 462, height: 260 },
        hover: {
          [SITE_PLATFORM_MOBILE]: { width: 490, height: 276 },
          [SITE_PLATFORM_TABLET]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB_LARGE]: { width: 490, height: 276 },
        },
      };
    }
    case COLLECTION_VIDEO_BANNER_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 540, height: 303 },
        [SITE_PLATFORM_TABLET]: { width: 540, height: 303 },
        [SITE_PLATFORM_WEB]: { width: 540, height: 303 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 540, height: 303 },
      };
    }
    case COUNTDOWN_BANNER_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 375 },
        [SITE_PLATFORM_TABLET]: { height: 199 },
        [SITE_PLATFORM_WEB]: { height: 280 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 310 },
      };
    }
    case EPG_LIVE_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 231, height: 130 },
        [SITE_PLATFORM_TABLET]: { width: 231, height: 130 },
        [SITE_PLATFORM_WEB]: { width: 231, height: 130 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 231, height: 130 },
      };
    }
    case FOOTER_PROMO: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 370, height: 208 },
        [SITE_PLATFORM_TABLET]: { width: 1035, height: 582 },
        [SITE_PLATFORM_WEB]: { width: 270, height: 150 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 270, height: 150 },
      };
    }
    case FUTURE_EPG_MODAL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 536, height: 302 },
        [SITE_PLATFORM_TABLET]: { width: 536, height: 302 },
        [SITE_PLATFORM_WEB]: { width: 536, height: 302 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 536, height: 302 },
      };
    }
    case HOW_TO_WATCH_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 741 },
        [SITE_PLATFORM_TABLET]: { width: 579 },
        [SITE_PLATFORM_WEB]: { width: 741 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1024 },
      };
    }
    case HOME_HERO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 375, height: 500 },
        [SITE_PLATFORM_TABLET]: { width: 768, height: 1098 },
        [SITE_PLATFORM_WEB]: { width: 768, height: 1098 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 768, height: 1098 },
      };
    }
    case HOME_HEADER_TITLE_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 36 },
        [SITE_PLATFORM_TABLET]: { height: 36 },
        [SITE_PLATFORM_WEB]: { height: 54 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 54 },
      };
    }
    case HOME_SMALL_PROMO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 375, height: 132 },
        [SITE_PLATFORM_TABLET]: { width: 375, height: 132 },
        [SITE_PLATFORM_WEB]: { width: 1071, height: 359 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1071, height: 359 },
      };
    }
    case HOME_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 336, height: 189 },
        [SITE_PLATFORM_TABLET]: { width: 349, height: 196 },
        [SITE_PLATFORM_WEB]: { width: 349, height: 196 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 349, height: 196 },
      };
    }
    case LIVE_EPG_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 325, height: 182 },
        [SITE_PLATFORM_TABLET]: { width: 325, height: 182 },
        [SITE_PLATFORM_WEB]: { width: 325, height: 182 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 325, height: 182 },
      };
    }
    case LIVE_PLAYER_BACKGROUND_IMAGE:
    case WATCH_PLAYER_BACKGROUND_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 375, height: 211 },
        [SITE_PLATFORM_TABLET]: { width: 768, height: 432 },
        [SITE_PLATFORM_WEB]: { width: 1135, height: 638 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1135, height: 638 },
      };
    }
    case MARKET_VIDEO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 290, height: 163 },
        [SITE_PLATFORM_TABLET]: { width: 463, height: 260 },
        [SITE_PLATFORM_WEB]: { width: 618, height: 347 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 868, height: 488 },
      };
    }
    case CHANNEL_BACKGROUND_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 180 },
        [SITE_PLATFORM_TABLET]: { height: 120 },
        [SITE_PLATFORM_WEB]: { height: 250 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 400 },
      };
    }
    case CHANNEL_LOGO_BANNER: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 34 },
        [SITE_PLATFORM_TABLET]: { height: 48 },
        [SITE_PLATFORM_WEB]: { height: 52 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 52 },
      };
    }
    case NETWORK_LOGO_IMAGE:
    case POSTER_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 287 },
        [SITE_PLATFORM_TABLET]: { height: 362 },
        [SITE_PLATFORM_WEB]: { height: 597 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 800 },
      };
    }
    case POSTER_OVERLAY_LOGO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 62 },
        [SITE_PLATFORM_TABLET]: { height: 75 },
        [SITE_PLATFORM_WEB]: { height: 85 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 120 },
      };
    }
    case POSTER_OVERLAY_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 132 },
        [SITE_PLATFORM_TABLET]: { height: 132 },
        [SITE_PLATFORM_WEB]: { height: 170 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 219 },
      };
    }
    case SEARCH_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 356, height: 200 },
        [SITE_PLATFORM_TABLET]: { width: 325, height: 182 },
        [SITE_PLATFORM_WEB]: { width: 500, height: 280 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 900, height: 550 },
      };
    }

    case SERIES_DETAIL_HERO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 575 },
        [SITE_PLATFORM_TABLET]: { height: 620 },
        [SITE_PLATFORM_WEB]: { height: 1250 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 1600 },
      };
    }
    case SERIES_DETAIL_LOGO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 69 },
        [SITE_PLATFORM_TABLET]: { height: 102 },
        [SITE_PLATFORM_WEB]: { height: 129 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 129 },
      };
    }
    case SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 278 },
        [SITE_PLATFORM_TABLET]: { height: 180 },
        [SITE_PLATFORM_WEB]: { height: 312 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 312 },
      };
    }
    case SHOW_DETAIL_RELATED_THUMBNAIL_IMAGE:
    case SMALL_PROMO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 733 },
        [SITE_PLATFORM_TABLET]: { width: 1071 },
        [SITE_PLATFORM_WEB]: { width: 1920 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1920 },
      };
    }
    case SPORT_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 257, height: 145 },
        [SITE_PLATFORM_TABLET]: { width: 257, height: 145 },
        [SITE_PLATFORM_WEB]: { width: 257, height: 145 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 257, height: 145 },
      };
    }
    case WATCH_RELATED_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 351, height: 198 },
        [SITE_PLATFORM_TABLET]: { width: 351, height: 198 },
        [SITE_PLATFORM_WEB]: { width: 261, height: 147 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 261, height: 147 },
      };
    }

    case SEARCH_EPISODE_TILE_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 125, height: 75 },
        [SITE_PLATFORM_TABLET]: { width: 450, height: 250 },
        [SITE_PLATFORM_WEB]: { width: 500, height: 290 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 720, height: 450 },
      };
    }

    default: {
      console.warn('image size does not exist', context);
      return {};
    }
  }
};

const generateImageUrl = ({ url, width, height, unoptimized }) => {
  const originalUrl = url;
  if (!url) return null;

  // fastly experiment
  if (url.indexOf('static-media.fox.com') > 0) {
    // eslint-disable-next-line no-param-reassign
    url = url.replace('static-media.fox.com', 's.foxdcg.com');
  }

  if (url.indexOf('assets.foxdcg.com') > 0) {
    // eslint-disable-next-line no-param-reassign
    url = url.replace('assets.foxdcg.com', 'a.foxdcg.com');
  }

  const defaultSize = '*';
  const imageUrlSuffix = '?fit=inside%7C';
  const imageFilter = '&auto=webp';
  const imageUrlSize = `${width || defaultSize}:${height || defaultSize}`;
  if (_.includes(url, imageUrlSuffix)) {
    const imageUrl = url.split('?')[0];
    return `${imageUrl}${imageUrlSuffix}${imageUrlSize}`;
  }
  if (unoptimized) return `${originalUrl}${imageUrlSuffix}${imageUrlSize}`.replace(/ /g, '%20');
  return `${url}${imageUrlSuffix}${imageUrlSize}${imageFilter}`.replace(/ /g, '%20');
};

/**
 * @param breakpoint
 * @param context
 * @param url
 * @param isHover
 * @returns {string|null}
 */
export const getDynamicImage = ({ breakpoint, context, url, isHover = false, unoptimized }) => {
  const imageSize = getImageSize({ context });
  const currentImageSize = isHover ? imageSize.hover[breakpoint] : imageSize[breakpoint];
  const width = currentImageSize?.width;
  const height = currentImageSize?.height;
  const imageUrl = generateImageUrl({ url, width, height, unoptimized });
  return imageUrl || null;
};

const getHighDensityImageUrl = ({ url, width, height, unoptimized }) => {
  if (!url) return null;
  return generateImageUrl({
    url,
    width: Math.round(width * HIGH_DENSITY_IMAGE_MULTIPLIER),
    height: Math.round(height * HIGH_DENSITY_IMAGE_MULTIPLIER),
    unoptimized,
  });
};

export const getStillBackgroundImage = ({ item }) => {
  if (!item) return null;
  const autoPlayStillImage = _.get(item, 'autoPlayStill.default.url', null);
  const seriesDetailImage = _.get(item, 'images.seriesDetail.raw', null);
  const stillBackgroundImage = _.get(item, 'images.videoList.raw', null);
  const seriesListImage = _.get(item, 'images.seriesList.raw', null);
  return autoPlayStillImage || seriesDetailImage || stillBackgroundImage || seriesListImage;
};

export const renderImage = ({
  alt,
  breakpoint,
  className,
  dataTest,
  preventLazyLoad,
  isHover,
  imageType,
  src,
  ...rest
}) => {
  let widthDimn;
  let heightDimn;
  let dynamicImageUrl;
  let highDensityImageUrl;
  const hasDimension = !!imageType && !!breakpoint;
  if (hasDimension) {
    dynamicImageUrl = getDynamicImage({ url: src, breakpoint, context: imageType, isHover });
    const imageSize = getImageSize({ context: imageType });
    const { width, height } = isHover ? imageSize.hover[breakpoint] : imageSize[breakpoint];
    widthDimn = width;
    heightDimn = height;
    highDensityImageUrl = getHighDensityImageUrl({ url: src, width, height });
  }

  const imageProps = {
    alt: alt || '',
    'data-test': dataTest,
    className,
    width: hasDimension ? widthDimn : null,
    height: hasDimension ? heightDimn : null,
    debounce: 300,
    decode: null,
    src: dynamicImageUrl || src,
    srcSet: highDensityImageUrl ? `${highDensityImageUrl} 2x` : highDensityImageUrl,
  };

  return <img alt={imageProps.alt} loading="lazy" {...imageProps} {...rest} />;
};
